import { render, staticRenderFns } from "./postulaciones-detalle.vue?vue&type=template&id=69b94e9c&lang=html"
import script from "./postulaciones-detalle.vue?vue&type=script&lang=js"
export * from "./postulaciones-detalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports